<!--
  Betriebsart ohne Einspeisung: keine Wechselrichter am Vorgang, der Abschnitt entfällt vollständig
  (keine leere Überschrift).
-->
<section *ngIf="gr?.producers?.length">
  <h3>Wechselrichter / Entladeleistung</h3>
  <section *ngFor="let producer of gr.producers">
    <h4>
      <span *ngIf="producer.count">{{ producer.count.toString() }} x</span>
      {{ producer.manufacturer }}
      <span *ngIf="producer.manufacturer && producer.deviceTypeName">-</span>
      {{ producer.deviceTypeName }}
    </h4>
    <div>
      <app-value-with-label
        *ngIf="producer.isExistingPowerInverter != null"
        [label]="'Speicher an einem bestehenden Wechselrichter übernommen:'"
        [value]="producer.isExistingPowerInverter | jaNeinPipe"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="producer.powerInverterType"
        [label]="'Wechselrichter-Typ:'"
        [value]="powerInverterTypeDisplayNames[producer.powerInverterType]"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="producer.zerezId"
        [label]="'ZEREZ-ID:'"
        [value]="producer.zerezId"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="producer.phases"
        [label]="'Anzahl der Phasen:'"
        [value]="producer.phases | phasesTypePipe"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="producer.connectedPhases"
        [label]="'Angeschlossene Phasen:'"
        [value]="producer.connectedPhases | connectedPhasenPipe"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="producer.acActivePowerMax"
        [label]="'AC-maximale Wirkleistung:'"
        [value]="(producer.acActivePowerMax | number : undefined : 'de-DE') + ' kW'"></app-value-with-label>
    </div>
    <div>
      <app-value-with-label
        *ngIf="producer.acApparentPowerMax"
        [label]="'AC-maximale Scheinleistung:'"
        [value]="
          (producer.acApparentPowerMax | number : undefined : 'de-DE') + ' kVA'
        "></app-value-with-label>
    </div>
  </section>
  <div>
    <app-value-with-label
      *ngIf="totalActivePower > 0"
      [label]="'<b>Gesamte AC-maximale Wirkleistung der Wechselrichter:</b>'"
      [value]="'<b>' + (totalActivePower | number : undefined : 'de-DE') + ' kW</b>'"></app-value-with-label>
  </div>
  <div>
    <app-value-with-label
      *ngIf="totalApparentPower > 0"
      [label]="'<b>Gesamte AC-maximale Scheinleistung der Wechselrichter:</b>'"
      [value]="
        '<b>' + (totalApparentPower | number : undefined : 'de-DE') + ' kVA</b>'
      "></app-value-with-label>
  </div>
  <!-- Die Entladeleistung des Speichers wird am ersten Wechselrichter geführt. -->
  <div>
    <app-value-with-label
      *ngIf="dischargePower != null"
      [label]="'Entladeleistung je Speichersystem:'"
      [value]="(dischargePower | number : undefined : 'de-DE') + ' kW'"></app-value-with-label>
  </div>
  <div>
    <app-value-with-label
      *ngIf="total(dischargePower) != null"
      [label]="'Gesamtentladeleistung der Speicher:'"
      [value]="(total(dischargePower) | number : undefined : 'de-DE') + ' kW'"></app-value-with-label>
  </div>
</section>

<!-- Betriebsart ohne Bezug: kein Verbraucher am Vorgang, der Abschnitt entfällt. -->
<section *ngIf="firstConsumer">
  <h3>Angaben zum Bezug/Verbrauch</h3>
  <div>
    <app-value-with-label
      *ngIf="firstConsumer.chargePower != null"
      [label]="'Ladeleistung je Speichersystem:'"
      [value]="(firstConsumer.chargePower | number : undefined : 'de-DE') + ' kW'"></app-value-with-label>
  </div>
  <div>
    <app-value-with-label
      *ngIf="total(firstConsumer.chargePower) != null"
      [label]="'Gesamtladeleistung der Speicher:'"
      [value]="
        (total(firstConsumer.chargePower) | number : undefined : 'de-DE') + ' kW'
      "></app-value-with-label>
  </div>
  <div>
    <app-value-with-label
      *ngIf="firstConsumer.power != null"
      [label]="'Wechselrichterleistung je Speichersystem:'"
      [value]="(firstConsumer.power | number : undefined : 'de-DE') + ' kW'"></app-value-with-label>
  </div>
  <div>
    <app-value-with-label
      *ngIf="firstConsumer.rateLimitingType"
      [label]="'Wirkleistung steuerbar nach § 14a EnWG:'"
      [value]="
        firstConsumer.rateLimitingType | appDisplayName : (metaService.rateLimitingTypes$ | async)
      "></app-value-with-label>
  </div>
  <div>
    <app-value-with-label
      *ngIf="firstConsumer.controllability"
      [label]="'Bereitstellung der Steuerbarkeit:'"
      [value]="
        firstConsumer.controllability === 'NB' ? 'Netzbetreiber' : 'Messstellenbetreiber'
      "></app-value-with-label>
  </div>
  <div>
    <app-value-with-label
      *ngIf="firstConsumer.meterOperator"
      [label]="'Messstellenbetreiber:'"
      [value]="firstConsumer.meterOperator"></app-value-with-label>
  </div>
</section>
